// Niveis de perfil unificados (mesma numeracao do backend).
// 0=USUARIO, 1=ADMINISTRADOR, 2=GERENTE, 3=MASTER (novo).
export enum Perfil {
  USUARIO = 0,
  ADMINISTRADOR = 1,
  GERENTE = 2,
  MASTER = 3,
}

// Substitui o antigo check de `versaoDesenvolvedor`. Todas as telas que liberavam
// recursos pela flag agora devem usar isMaster(user).
export const isMaster = (user: any): boolean => Number(user?.perfil) === Perfil.MASTER;
export const isAdministrador = (user: any): boolean => Number(user?.perfil) === Perfil.ADMINISTRADOR;
export const isAdminOrMaster = (user: any): boolean => {
  const p = Number(user?.perfil);
  return p === Perfil.ADMINISTRADOR || p === Perfil.MASTER;
};
export const isGerente = (user: any): boolean => Number(user?.perfil) === Perfil.GERENTE;
export const isUsuarioComum = (user: any): boolean => Number(user?.perfil) === Perfil.USUARIO;

/**
 * Pode gravar cadastros administrativos (APK, aplicativo, entidade, regional)?
 *
 * BUG QUE ISTO CORRIGE: cinco telas usavam `disabled={user.perfil != 1}`, o que
 * habilitava o botao Salvar APENAS para Administrador (1) e travava o MASTER (3).
 * Como o menu e os botoes "Novo" dessas telas so aparecem para Master, o
 * resultado era: o Master abria o formulario e o Salvar estava desabilitado, sem
 * nenhuma explicacao; e o Administrador podia salvar mas nao tinha como chegar
 * ate a tela. Ninguem conseguia concluir o cadastro.
 *
 * A causa foi a migracao da flag `versaoDesenvolvedor` para o enum de perfil: o
 * resto do sistema passou a usar isMaster(), estes cinco pontos ficaram atras.
 *
 * Pontos corrigidos: apks/new/[id], aplicativos/new/[packageName],
 * entidades/index, entidades/components/list/InvoiceTableRow,
 * regionais/new/[codigo].
 *
 * Centralizado aqui de proposito: se a regra mudar (por ex. incluir Gerente),
 * muda em UM lugar em vez de cinco.
 */
export const podeGravarCadastroAdmin = (user: any): boolean =>
  isMaster(user) || isAdministrador(user);

/**
 * Substituir o ARQUIVO de uma APK (mantendo o mesmo nome e a mesma URL).
 *
 * Regra normal: somente Master.
 *
 * LIBERACAO TEMPORARIA ATE 12/09/2026: Administrador e Gerente tambem podem,
 * porque houve perda de arquivos de APK e a equipe precisa reenviar os binarios.
 * Depois da data a regra volta sozinha para Master-only, sem depender de alguem
 * lembrar de remover codigo.
 *
 * A AUTORIDADE e o backend (apks.service.substituirArquivo, que tem a mesma
 * data). Esta funcao serve apenas para nao exibir uma opcao que iria falhar.
 * Se as duas datas divergirem, quem manda e o backend.
 */
export const LIBERACAO_SUBSTITUIR_APK_ATE = new Date('2026-09-12T23:59:59-03:00');

export const podeSubstituirArquivoApk = (user: any): boolean => {
  if (isMaster(user)) return true;
  const dentroDaJanela = new Date() <= LIBERACAO_SUBSTITUIR_APK_ATE;
  return dentroDaJanela && (isAdministrador(user) || isGerente(user));
};

export const perfilLabel = (perfil: number | undefined | null): string => {
  switch (Number(perfil)) {
    case Perfil.USUARIO: return 'Usuário';
    case Perfil.ADMINISTRADOR: return 'Administrador';
    case Perfil.GERENTE: return 'Gerente';
    case Perfil.MASTER: return 'Master';
    default: return '-';
  }
};
